export enum AccessControlledComponents {
	SettingsGear = 'SettingsGear',
	RefundPayment = 'RefundPayment',
	SuperAdminAccessArea = 'SuperAdminAccessArea',
	CopyRateSetupButton = 'CopyRateSetupButton',
	AdminControlTool = 'AdminControlTool',
	SubscriptionDetailDiscountCreditButton = 'SubscriptionDetailDiscountCreditButton',
	SubscriptionDetailCarryoverCreditButton = 'SubscriptionDetailCarryoverCreditButton',
	DashboardPage = 'DashboardPage',
	SubscriptionsPage = 'SubscriptionsPage',
	FacilitiesPage = 'FacilitiesPage',
	InvoicesPage = 'InvoicesPage',
	ParkersPage = 'ParkersPage',
	PaymentAppPage = 'PaymentAppPage',
	CreditsPage = 'CreditsPage',
	PaymentsPage = 'PaymentsPage',
	RatesPage = 'RatesPage',
	ReportsPage = 'ReportsPage',
	ReportsPageOutstandingBalancesReportTab = 'ReportsPageOutstandingBalancesReportTab',
	ReportsPageInvoiceReportTab = 'ReportsPageInvoiceReportTab',
	ReportsPagePreviewAutoInvoiceReportTab = 'ReportsPagePreviewAutoInvoiceReportTab',
	ReportsPagePaymentReportTab = 'ReportsPagePaymentReportTab',
	ReportsPageSignUpTerminationReportTab = 'ReportsPageSignUpTerminationReportTab',
	ReportsPageTransactionReportTab = 'ReportsPageTransactionReportTab',
	ReportsPageMissingDrReportTab = 'ReportsPageMissingDrReportTab',
	ReportsPageDailyRevenueReportTab = 'ReportsPageDailyRevenueReportTab',
	ReportsPageBankReconciliationReportTab = 'ReportsPageBankReconciliationReportTab',
	ReportsPageTaxReportTab = 'ReportsPageTaxReportTab',
	ReportsPageSubscriptionActivityReportTab = 'ReportsPageSubscriptionActivityReportTab',
	ReportsPageFacilitySettingsReportTab = 'ReportsPageFacilitySettingsReportTab',
	ReportsPageLeaseManagerAllocationReportTab = 'ReportsPageLeaseManagerAllocationReportTab',
	ReportsPageManagementSummaryReportTab = 'ReportsPageManagementSummaryReportTab',
	ReservationsPage = 'ReservationsPage',
	DailyReportsPage = 'DailyReportsPage',
	HourlyS2PPage = 'HourlyS2PPage',
	ZonesEdit = 'zonesEdit',
	DefaultEventRatesTab = 'DefaultEventRatesTab',
	DefaultEventRatesTableButton = 'DefaultEventRatesTableButton',
	PortalsPage = 'PortalsPage',
	DailyReportingToggle = 'DailyReportingToggle',
	UsersTable = 'UsersTable',
	ApproveBatchButton = 'ApproveBatchButton',
	AddFacilityFromWordpressButton = 'AddFacilityFromWordpressButton',
	UpdateFacilityFromWordpressButton = 'UpdateFacilityFromWordpressButton',
	BulkEmailIcon = 'BulkEmailIcon',
	UserExternalApiPermissionsTable = 'UserExternalApiPermissionsTable',
	InvoiceDueDateEditIcon = 'InvoiceDueDateEditIcon',
	DefaultRates = 'DefaultRates',
	VehicleSurcharges = 'VehicleSurcharges',
	FacilityIntegrationSettings = 'FacilityIntegrationSettings',
	BulkEmailDashboardButton = 'BulkEmailDashboardButton',
	CreateBatchButton = 'CreateBatchButton',
	RefundParkingSessionButton = 'RefundParkingSessionButton',
	HourlyPromoCodesEditButton = 'HourlyPromoCodesEditButton',
	FacilityPaymentSettings = 'FacilityPaymentSettings',
	FacilityPaymentSettingsActions = 'FacilityPaymentSettingsActions',
	PurchaseSurveyQuestionsEdit = 'PurchaseSurveyQuestionsEdit',
	HourlyTermsAndConditionsEditButton = 'HourlyTermsAndConditionsEditButton',
	HourlyOpenClosedHours = 'HourlyOpenClosedHours',
	UserHistoryTable = 'UserHistoryTable',
	AuditHistoryTable = 'AuditHistoryTable',
	AuditHistoryCloudWatchLink = 'AuditHistoryCloudWatchLink',
	NewHourlyReservations = 'NewHourlyReservations',
	SyncFacilityGeoLocationsButton = 'SyncFacilityGeoLocationsButton',
	SubscriptionsTableDeleteIcon = 'SubscriptionsTableDeleteIcon',
	WordpressButton = 'WordpressButton',
	SubscriptionsPageGeneralTableExportButton = 'SubscriptionsPageGeneralTableExportButton',
	SubscriptionsPageGeneralTableBulkUploadButton = 'SubscriptionsPageGeneralTableBulkUploadButton',
	SubscriptionsPageContractRulesTab = 'SubscriptionsPageContractRulesTab',
	SubscriptionsPageContractDocsTab = 'SubscriptionsPageContractDocsTab',
	SubscriptionsPageTaxExemptCertificatesTab = 'SubscriptionsPageTaxExemptCertificatesTab',
	SubscriptionsAddressesPageExportButton = 'SubscriptionsAddressesPageExportButton',
	SubscriptionInfoPageManualInvoiceButton = 'SubscriptionInfoPageManualInvoiceButton',
	SubscriptionInfoPageUploadTaxExemptCertificateButton = 'SubscriptionInfoPageUploadTaxExemptCertificateButton',
	SubscriptionInfoSettingsPage = 'SubscriptionInfoSettingsPage',
	SubscriptionInfoSettingsEditButton = 'SubscriptionInfoSettingsEditButton',
	SubscriptionInfoParkersPageExportButton = 'SubscriptionInfoParkersPageExportButton',
	SubscriptionInfoParkersPageBulkUploadButton = 'SubscriptionInfoParkersPageBulkUploadButton',
	SubscriptionInfoParkersPageAddBarcodesButton = 'SubscriptionInfoParkersPageAddBarcodesButton',
	SubscriptionInfoParkersPageRateLink = 'SubscriptionInfoParkersPageRateLink',
	SubscriptionInfoParkersPageBulkDeletePendingParkersAction = 'SubscriptionInfoParkersPageBulkDeletePendingParkersAction',
	SubscriptionInfoParkersPageBulkDeleteAllPendingParkersAction = 'SubscriptionInfoParkersPageBulkDeleteAllPendingParkersAction',
	SubscriptionInfoParkersPageBulkRemoveAccessSystemMetaForSelectedParkersAction = 'SubscriptionInfoParkersPageBulkRemoveAccessSystemMetaForSelectedParkersAction',
	SubscriptionInfoParkersPageBulkRemoveAccessSystemMetaOnSubscriptionAndParkersAction = 'SubscriptionInfoParkersPageBulkRemoveAccessSystemMetaOnSubscriptionAndParkersAction',
	SubscriptionInfoParkersPageBulkSuspendParkersAction = 'SubscriptionInfoParkersPageBulkSuspendParkersAction',
	SubscriptionInfoParkersPageBulkUnsuspendParkersAction = 'SubscriptionInfoParkersPageBulkUnsuspendParkersAction',
	SubscriptionInfoParkersPageBulkUpdateTerminationPendingParkersAction = 'SubscriptionInfoParkersPageBulkUpdateTerminationPendingParkersAction',
	SubscriptionInfoParkersPageBulkUpdateSuspensionPendingParkersAction = 'SubscriptionInfoParkersPageBulkUpdateSuspensionPendingParkersAction',
	SubscriptionInfoParkersPageBulkChangePendingParkerStartDateAction = 'SubscriptionInfoParkersPageBulkChangePendingParkerStartDateAction',
	SubscriptionInfoPageWaitlistTab = 'SubscriptionInfoPageWaitlistTab',
	SubscriptionInfoHistoryPageDownloadOBReportButton = 'SubscriptionInfoHistoryPageDownloadOBReportButton',
	SubscriptionInfoHistoryTableExportButton = 'SubscriptionInfoHistoryTableExportButton',
	SubscriptionInfoPageTenantPortalTab = 'SubscriptionInfoPageTenantPortalTab',
	SubscriptionInfoPageLeasesTab = 'SubscriptionInfoPageLeasesTab',
	ParkerDetailModalScheduleRateChangeButton = 'ParkerDetailModalScheduleRateChangeButton',
	ParkerDetailModalScheduleSublotChangeButton = 'ParkerDetailModalScheduleSublotChangeButton',
	FacilitiesBuildingsButton = 'FacilitiesBuildingsButton',
	FacilitiesBillingSettingsAlerts = 'FacilitiesBillingSettingsAlerts',
	FacilitiesBillingSettings = 'FacilitiesBillingSettings',
	ParkerDetailModalDefaultRatesMonthlyFeeLessThan50 = 'ParkerDetailModalDefaultRatesMonthlyFeeLessThan50',
	ShowTurnOffAutoApplyCreditsForSubscriptionsButton = 'ShowTurnOffAutoApplyCreditsForSubscriptionsButton',
	SubscriptionInfoPaymentLogs = 'SubscriptionInfoPaymentLogs',
	PaymentsTablePaymentLogs = 'PaymentsTablePaymentLogs',
	InvoiceDetailPaymentLogs = 'InvoiceDetailPaymentLogs',
	ParkerDetailModalAssignReservedSpaceButton = 'ParkerDetailModalAssignReservedSpaceButton',
	ReservationCheckoutPageButton = 'ReservationCheckoutPageButton',
	ParkerDetailModalParkerTypeEditable = 'ParkerDetailModalParkerTypeEditable',
}
